module.exports = __webpack_public_path__ + "static/media/24UHCHR18.927f797b.jpg";